import { Col1, Row } from "../lib";
import { createStyles, sizes } from "../theme";
import { DetailIcon } from "./detail-icon";

type Props = {
  score: number | null;
  quality: number | null;
  premium?: boolean;
};

export function BookingItemUser({ score, quality, premium = false }: Props) {
  return (
    <Row.LR style={$.container}>
      <Col1 style={$.item}>
        <DetailIcon
          icon={score ? "star" : "star-outline"}
          title="Score"
          value={score || "No score"}
          active={!!score}
        />
      </Col1>
      <Col1 style={$.item}>
        <DetailIcon
          icon={quality ? "thumb-up" : "thumb-up-outline"}
          title="Quality"
          value={quality || "No review"}
          active={!!quality}
        />
      </Col1>
      <Col1 style={$.item}>
        <DetailIcon
          icon={premium ? "star-box" : "star-box-outline"}
          title="Paid"
          value={premium ? "Premium" : "Not premium"}
          active={premium}
        />
      </Col1>
    </Row.LR>
  );
}

const $ = createStyles({
  container: {
    gap: sizes["3"],
  },
  item: {
    borderWidth: 1,
    borderColor: "outline",
    borderRadius: "2",
    p: "2",
  },
});
